import React from 'react';
import { Navigate } from 'react-router-dom';
import { useAuth } from '../../hooks';

export function ProtectedRoute({ children }) {
    const { isAuthenticated, isInitialized } = useAuth();

    // Show loading state while initializing
    if (!isInitialized) {
        return (
            <div className="min-h-screen flex items-center justify-center">
                <div className="animate-spin rounded-full h-8 w-8 border-b-2 border-indigo-600"></div>
            </div>
        );
    }

    return isAuthenticated ? children : <Navigate to="/" replace />;
}
